import type { AsyncAvData } from "@ui/hooks/useSessionAsyncAv";

import type { InitAsyncVerificationResponse } from "@jti/fe-common";

import type { AvUserDataType } from "../../interfaces/AvUserDataType";

const REDIRECTED_FROM_ASYNC_METHOD_PARAM = "redirectedFromAsyncMethod";

export const getAsyncProviderRedirectUrl = (
  asyncVerificationData: InitAsyncVerificationResponse
): string | undefined => {
  const veriffRedirectUrl = asyncVerificationData.data?.response_body?.verification?.url;
  const adapterRedirectUrl = asyncVerificationData.data?.redirectUrl;

  return veriffRedirectUrl || adapterRedirectUrl;
};

export const buildAsyncRedirectCallbackUrl = (baseUrl: string, methodCode: string): string => {
  const hashIndex = baseUrl.indexOf("#");
  const routeStartIndex = hashIndex === -1 ? 0 : hashIndex;
  const hasRouteQuery = baseUrl.indexOf("?", routeStartIndex) !== -1;
  const separator = hasRouteQuery ? "&" : "?";

  return `${baseUrl}${separator}${REDIRECTED_FROM_ASYNC_METHOD_PARAM}=${methodCode}`;
};

export const mapUserDataToAsyncAvData = (
  userData: Partial<AvUserDataType>
): Pick<AsyncAvData, "dateOfBirth" | "email" | "firstName" | "lastName"> => ({
  dateOfBirth: userData?.dateOfBirth ?? "",
  email: userData?.email ?? "",
  firstName: userData?.firstname ?? "",
  lastName: userData?.lastname ?? "",
});
